import { useEffect } from 'react';
import { useGlobalSeismoUI, useSeismoUI } from '@bizzabo/seismo-ui';
import config from 'config';

export const useBootstrapSeismoUI = (session) => {
    useGlobalSeismoUI(config.seismoHost, { globalAudio: true, enableTracking: false });
    const globalSeismoUI = useSeismoUI();
    const shouldStartSeismo = getShouldStartSeismo(session);
    const shouldStartSeismoSound = getShouldStartSeismoSound(session);

    useEffect(() => {
        if (shouldStartSeismo) {
            globalSeismoUI.get()?.start(`bizzabo-${session.id}`, {
                startAudio: shouldStartSeismoSound,
                useAudio: shouldStartSeismoSound,
                globalVolume: true
            });
        }

        return () => {
            globalSeismoUI.get()?.shutdown();
        };
    }, [shouldStartSeismo, shouldStartSeismoSound]);

    return { shouldStartSeismo, shouldStartSeismoSound };
};

const getShouldStartSeismo = (session) => {
    const isReactionsEnabled = session.reactions?.enableEmojis;
    const isLiveVideo = session?.enableVirtualSession;

    return Boolean(isLiveVideo && isReactionsEnabled);
};

const getShouldStartSeismoSound = (session) => Boolean(session.reactions?.enableSound);
